import scrollEvent from '../../components/fsUtils/scrollEvent';

class CollectionsNav {
    constructor(){
        let isCollectionSF = document.querySelector('.collections-section-front');
        if( isCollectionSF ) {
            this.header = document.getElementById('body-header-wrapper');
            this.scorestrip = document.getElementById('#ScorestripContainer');
            this.scorestripHeght = this.scorestrip ? this.scorestrip.clientHeight : 65;
            this.mainNav = document.getElementById('header-wrapper');
            this.headerHeight = this.header ? this.header.clientHeight : 111;
            this.colNavWrapper = document.querySelector('.col-nav-wrapper');
            this.colNavContainer = this.colNavWrapper.querySelector('.col-nav-container');
            this.navWrao = this.colNavWrapper.querySelector('.nav-wrap');
            this.colNav = this.colNavWrapper.querySelector('.col-nav');
            this.collections = document.querySelectorAll('div[id*=collection]');
            if(this.colNavWrapper) {
                this.collectionsNavLinks = this.colNavWrapper.querySelectorAll('a');
                this.leftArrow = document.querySelector('.left-arrow');
                this.rightArrow = document.querySelector('.right-arrow'); 
            }
            this.travelDistance = 150; 
            this.scrollPerTick = 10;
            this.lastId = undefined;
            this.currentId = undefined;
            this.items = [];
            this.throttle = ('ontouchstart' in document.documentElement) ? 50 : 10;
            this.navHandler();
            this.navArrowHandler();
            this.pinner = this.pinHandler.bind(this);
            this.pinner = scrollEvent.throttle(this.pinner, this.throttle);
    
            //handle pinning and active menu items
            window.addEventListener('scroll', this.pinner);
        }
    }
    /**
     * Scrolls into view the collection item the user clicks on
     */
    navHandler(){
        if(this.collectionsNavLinks){
            for (let i = 0, l = this.collectionsNavLinks.length; i < l; i++) {
                let link = this.collectionsNavLinks[i];
                link.addEventListener('click', (e)=>{
                    e.preventDefault();
                    let collection = document.querySelector(link.hash);
                    if(collection){
                        scrollEvent.scrollTo( collection );
                        let selectedLink = this.colNav.querySelector('a.selected');
                        if(selectedLink){
                            selectedLink.classList.remove('selected');
                        }
                        link.classList.add('selected');
                    }
                });
            }
        }
    }

    pinHandler() {
        if (this.header) this.headerHeight = this.header.clientHeight;
        let navRect =  this.colNavWrapper.getBoundingClientRect(); //In order to get the pin off set properly, we need this.
        if(navRect.top < this.headerHeight) {
            if( this.colNavContainer ) {
                this.colNavContainer.classList.add('fixed');
                this.colNavContainer.style.top = this.headerHeight + 'px';
            }
        }
        else{
            this.colNavContainer.classList.remove('fixed');
        }
        if(this.items.length <= 0){
            this.items = document.querySelectorAll('div[id*=collection]');
        } else {
            //get current div in view
            this.items.forEach((item) => { 
                if((item.offsetTop - this.colNavWrapper.clientHeight) < window.scrollY) {
                        this.currentId = item.getAttribute('id');
                }
            });
            //add the selected class if ids do not match
            if(this.lastId !== this.currentId){
                this.lastId = this.currentId;
                let link =  this.colNavContainer.querySelector('a[href*=' + this.currentId + ']');
                let selectedLink = this.colNav.querySelector('a.selected');
                if(selectedLink){
                    selectedLink.classList.remove('selected');
                }
                if(link && !link.classList.contains('selected')) {
                    link.classList.add('selected');
                    this.colNav.scrollLeft += (link.getBoundingClientRect().x - (link.clientWidth/2));
                }
            }
        }
    }

    /**
     * Scrolls right or left when clicking on arrows on collections nav
     */
    navArrowHandler(){
        //set direction when page load
        let navUl = this.colNav.querySelector('ul');
        if( this.navWrao ) {
            let flowDirection = this.getFlowDirection(navUl, this.colNav);
            this.navWrao.setAttribute('direction', flowDirection );
    
            this.leftArrow.addEventListener('click', (e) => {
                let scrollAmount = 0;
                let slideTimer = setInterval(() => {
                    this.colNav.scrollLeft -= this.scrollPerTick;
                    scrollAmount += this.scrollPerTick;
                    if(scrollAmount >= this.travelDistance){
                        window.clearInterval(slideTimer);
                    }
                }, 15);
                let flowDirection = this.getFlowDirection(navUl, this.colNav);
                this.navWrao.setAttribute('direction', flowDirection );
            })
            this.rightArrow.addEventListener('click', (e) => {
                let scrollAmount = 0;
                let slideTimer = setInterval(() => {
                    this.colNav.scrollLeft += this.scrollPerTick;
                    scrollAmount += this.scrollPerTick;
                    if(scrollAmount >= this.travelDistance){
                        window.clearInterval(slideTimer);
                    }
                }, 15);
                let flowDirection = this.getFlowDirection(navUl, this.colNav);
                this.navWrao.setAttribute('direction', flowDirection );

            })
    
            this.colNav.addEventListener('scroll', (e) => {
                let flowDirection = this.getFlowDirection(navUl, this.colNav);
                this.navWrao.setAttribute('direction', flowDirection );
            });
        }
    }

    /**
     * 
     * @param {*} ul 
     * @param {*} container 
     */
    getFlowDirection(ul, container) {
        var containerMetrics = container.getBoundingClientRect();
        var containerMetricsRight = Math.floor(containerMetrics.right);
        var containerMetricsLeft = Math.floor(containerMetrics.left);
        var contentMetrics = ul.getBoundingClientRect();
        var contentMetricsRight = Math.floor(contentMetrics.right);
        var contentMetricsLeft = Math.floor(contentMetrics.left);
         if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
            return "both";
        } else if (contentMetricsLeft < containerMetricsLeft) {
            return "left";
        } else if (contentMetricsRight > containerMetricsRight) {
            return "right";
        } else {
            return "none";
        }
    }



}

export default CollectionsNav;


// WEBPACK FOOTER //
// ./assets/components/collections-nav/CollectionsNav.js